"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorResponseToJSON = exports.ErrorResponseFromJSONTyped = exports.ErrorResponseFromJSON = exports.instanceOfErrorResponse = void 0;
var runtime_1 = require("../runtime");
var ErrorCode_1 = require("./ErrorCode");
/**
 * Check if a given object implements the ErrorResponse interface.
 */
function instanceOfErrorResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfErrorResponse = instanceOfErrorResponse;
function ErrorResponseFromJSON(json) {
    return ErrorResponseFromJSONTyped(json, false);
}
exports.ErrorResponseFromJSON = ErrorResponseFromJSON;
function ErrorResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'spTraceId': !(0, runtime_1.exists)(json, 'sp_trace_id') ? undefined : json['sp_trace_id'],
        'messages': !(0, runtime_1.exists)(json, 'messages') ? undefined : json['messages'],
        'errorCodes': !(0, runtime_1.exists)(json, 'error_codes') ? undefined : (json['error_codes'].map(ErrorCode_1.ErrorCodeFromJSON)),
    };
}
exports.ErrorResponseFromJSONTyped = ErrorResponseFromJSONTyped;
function ErrorResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sp_trace_id': value.spTraceId,
        'messages': value.messages,
        'error_codes': value.errorCodes === undefined ? undefined : (value.errorCodes.map(ErrorCode_1.ErrorCodeToJSON)),
    };
}
exports.ErrorResponseToJSON = ErrorResponseToJSON;
